import React, { useEffect, useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  setQuestionAnswer,
  setQuestionAnswerFrench
} from "../../../../redux/actions";
import BackAnchor from "../../../../shared/components/BackAnchor";
import { addToGoogleDataLayer } from "../../../../shared/const/utls";
import ContinueCancelButtons from "../../../../shared/components/ContinueCancelButtons";
import { situationChangeOptions } from "../../../../shared/const/data";
import { useNavigate, useParams } from "react-router-dom";

const ApplicantSituationChangeView = ({ t, i18n }) => {
  const dispatch = useDispatch();
  const { questionDataList } = useSelector((state) => state?.app);
  const navigate = useNavigate();
  const params = useParams();
  const anotherAdultState =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 16)
    ].questionAnswer;
  const [situationChange, setSituationChange] = useState();
  const [situationChangeFrench, setSituationChangeFrench] =
    useState(anotherAdultState);

  const [situationChangeError, setSituationChangeError] = useState(false);
  const disableGApush = useMemo(() => {
    return JSON.parse(params?.disableGA || false);
  }, [params]);

  const options = situationChangeOptions;

  useEffect(() => {
    if (!disableGApush) {
      try {
        addToGoogleDataLayer("household-type", "HARP", i18n.language);
        window.scrollTo(0, 0);
      } catch (e) {
        console.log(e);
      }
    }

    if (i18n?.language === "en") {
      document.title =
        "Situation Change - HARP - Government of Nova Scotia";
    } else {
      document.title =
        "Changement de situation – PAC – Gouvernement de la Nouvelle-Écosse";
    }
  }, [i18n.language, situationChange, disableGApush]);

  const onNext = () => {
    if (!situationChange) {
      setSituationChangeError(true);
      return;
    }
    try {
      if (situationChange) {
        dispatch(setQuestionAnswer(10, situationChange));
        dispatch(setQuestionAnswerFrench(10, situationChangeFrench));
        navigate(`/${i18n.language}${t("routes.harp_qualify")}`);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleReduxCleanup = () => {
    dispatch(setQuestionAnswer(10, ''));
    dispatch(setQuestionAnswerFrench(10, ''));
  }

  return (
    <div>
      <div className="container">
        <main>
          <article>
            <div className="row" style={{ paddingTop: "1em" }}></div>

            <BackAnchor backPath={"routes.net_income_check"} onBackClick={handleReduxCleanup} />

            <div className="row">
              <div className="col-sm-8 col-xs-11">
                <h1 style={{ marginBottom: "0" }}>
                  {t("situation_change.header")}
                </h1>
              </div>
              <div className="col-xs-12" style={{ marginTop: "10px" }}>
                <b>{t("situation_change.select_option")}</b>
              </div>
            </div>
            <div style={{ paddingBottom: "2em" }} className="row">
              <div className="col-xs-12 col-md-8">
                {situationChangeError && (
                  <div className="form-group has-error">
                    <div className="help-block">
                      <i
                        aria-label={t("errors.hidden_error_msg")}
                        className="fa fa-exclamation-circle error-indicator errorAlert"
                        aria-hidden="true"
                      />
                      <span className="ns-visually-hidden">
                        {t("errors.hidden_error_msg")}
                      </span>
                      <span style={{ marginLeft: "10px" }}>
                        {t("errors.situation_change_selection_missing")}
                      </span>
                    </div>
                  </div>
                )}
                {options.map((opt, index) => (
                  <div className="ns-radios__item col-xs-12" key={index}>
                    <input
                      className="ns-radios__input"
                      type="radio"
                      id={index}
                      name="own-radio"
                      value={opt?.value}
                      onChange={(e) => {
                        setSituationChangeError(false);
                        setSituationChange(e.target.value);
                        setSituationChangeFrench(e.target.value);
                      }}
                      checked={situationChange === opt?.value}
                    />
                    <label
                      onClick={() => {
                        setSituationChangeError(false);
                        setSituationChange(opt?.value);
                        setSituationChangeFrench(opt?.valueFrench);
                      }}
                      style={{ display: "block" }}
                      className=" ns-radios__label"
                      htmlFor="own-radio"
                      key="own-radio"
                    >
                      <p
                        className="ns-label ns-label-span"
                        style={{ marginBottom: "0" }}
                      >
                        {t(`situation_change.option_${opt?.id}`)}
                        {` \n`}
                      </p>
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <ContinueCancelButtons
              continueClick={onNext}
              isSignatureRequired={false}
            />
          </article>
        </main>
      </div>
    </div>
  );
};

export default withTranslation("common")(ApplicantSituationChangeView);
